import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

export interface ParametrosKpis {
  desde: string;
  hasta: string;
  idPlanta?: number | null | undefined;
}

/**
 * KPIs del periodo seleccionado. Disabled si falta `desde` o `hasta`
 * (la pantalla debería siempre tenerlos por default mes en curso).
 */
export function useKpis(params: ParametrosKpis | null) {
  const habilitado = !!params && !!params.desde && !!params.hasta;
  return useQuery({
    queryKey: ['kpis', params?.desde, params?.hasta, params?.idPlanta ?? null],
    queryFn: () => {
      if (!params) throw new Error('useKpis: params no debería ser null cuando enabled=true');
      return cliente.batches.obtenerKpis({
        desde: params.desde,
        hasta: params.hasta,
        ...(params.idPlanta != null ? { id_planta: params.idPlanta } : {}),
      });
    },
    staleTime: 30_000,
    enabled: habilitado,
  });
}
